import React from 'react';
import { Button } from '../../../../../ui';
import { jobOpeningPages } from '../../../../../utils/types/JobOpenings';

type StatusMessageProps = {
  status: 'disabled' | 'requiredCompletion' | 'enabled' | 'loading';
  requiredTabs?: string[];
  enabledElement?: () => void;
  setCurrentPage?: (page: any) => void;
  setStatusTab?: (subTab: any) => void;
};

const StatusMessage = ({
  status,
  requiredTabs,
  enabledElement,
  setCurrentPage,
  setStatusTab,
}: StatusMessageProps) => {
  const handleClick = (tab: string) => {
    if (setCurrentPage) {
      if (setStatusTab) {
        setStatusTab(tab);
        setCurrentPage('Job Opening Details');
      }
    }
  };

  return (
    <div className='flex items-center justify-center w-full'>
      <div className='text-center p-6'>
        { status === 'disabled' && (
          <div className='flex-col flex items-center justify-center'>
            <p className='text-gray-400 text-xl font-bold mb-4'>
              Sorry, this option is disabled.
            </p>
            { enabledElement && (
              <Button onClick={enabledElement} variant='primary' label='Enable'/>
            ) }
          </div>
        ) }
        { status === 'requiredCompletion' && requiredTabs && (
          <div>
            <p className='text-green-400 text-xl font-bold mb-4'>
              Please complete the following tabs before proceeding:
            </p>
            <ul className='list-none'>
              { requiredTabs.map((tab, index) => (
                <li
                    key={index}
                    className='text-gray-800 text-lg cursor-pointer hover:text-blue-600'
                    onClick={() => handleClick(tab)}
                >
                  { tab }
                </li>
              )) }
            </ul>
          </div>
        ) }
        { status === 'loading' && <div></div> }
      </div>
    </div>
  );
};

export default StatusMessage;
